import { PageHead } from '../components/index.js';
import { LangSwitch } from '../components/LangSwitch.js';
import { NAV } from '../nav.js';
import { t } from '../lib/i18n.js';
import { go, href } from '../lib/router.js';

export function More() {
  return (
    <>
      <PageHead title={t('more_title')}>
        <LangSwitch compact />
      </PageHead>
      <div class="list">
        {[
          ...NAV.filter((n) => !n.bottom),
          { name: 'settings' as const, label: 'nav_settings' as const, bottom: false },
        ].map((n) => (
          <a
            key={n.name}
            class="row"
            href={href(n.name)}
            onClick={(e) => (e.preventDefault(), go(n.name))}
            style={{ textDecoration: 'none' }}
          >
            <span>{t(n.label)}</span>
            <span class="muted">→</span>
          </a>
        ))}
      </div>
    </>
  );
}
